export default "__VITE_ASSET__4f77d3a2__"